const initialValue = {
	email: '',
	name: '',
};

const getStorage = (key: string) => {
	return sessionStorage.getItem(`@WelbeCompany:${key}`);
};

export const getUserInfo = () => {
	const company = getStorage('me');
	const initial = JSON.stringify(initialValue);
	const parsedCompany = JSON.parse(company || initial);

	return parsedCompany;
};
